import type { InputHTMLAttributes, ReactNode } from "react";
import { C } from "../tokens";

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange" | "prefix" | "size"> {
  value?: string;
  onChange?: (v: string) => void;
  prefix?: ReactNode;
  suffix?: ReactNode;
  size?: "sm" | "md";
}

export function Input({
  value, onChange, prefix, suffix, size = "sm", style, placeholder, ...rest
}: Props) {
  const pad = size === "md" ? 10 : 7;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        background: C.surfaceHigh,
        border: `1px solid ${C.border}`,
        borderRadius: 12,
        padding: `${pad}px 10px`,
        transition: "border-color 0.15s, box-shadow 0.15s",
      }}
      onFocus={(e) => {
        (e.currentTarget as HTMLDivElement).style.borderColor = C.borderBright;
        (e.currentTarget as HTMLDivElement).style.boxShadow = `0 0 0 2px rgba(45,127,249,0.15)`;
      }}
      onBlur={(e) => {
        (e.currentTarget as HTMLDivElement).style.borderColor = C.border;
        (e.currentTarget as HTMLDivElement).style.boxShadow = "none";
      }}
    >
      {prefix && <span style={{ color: C.textMuted, display: "flex" }}>{prefix}</span>}
      <input
        {...rest}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange?.(e.target.value)}
        style={{
          background: "transparent",
          border: "none",
          outline: "none",
          color: C.text,
          fontSize: size === "md" ? 13 : 12,
          flex: 1,
          minWidth: 0,
          ...style,
        }}
      />
      {suffix && <span style={{ color: C.textMuted, display: "flex" }}>{suffix}</span>}
    </div>
  );
}
